import React, { useEffect, useRef, useState } from 'react';
import './styles.css';

import Card from 'react-bootstrap/Card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHeart,
  faComment,
  faPaperPlane,
  faBookmark
} from '@fortawesome/free-solid-svg-icons';
import Image from 'react-bootstrap/Image';

import Carousel from 'react-bootstrap/Carousel';
import VideoComponent from './VideoComponent';
import { useTranslate } from '@tolgee/react';
import { PREVIEW_TYPE_COMPACT } from '../../config/constants';
import { useSelector, useDispatch } from 'react-redux';
import { setModalUiContent } from '../../../../redux/slices/lomavisCreator/lomavisCreator';
import { COMPACT_MODE_HEIGHT } from '../contants';
import OnImagesLoaded from '../../../onImagesLoaded';
import PreviewImagesSkeleton from '../loaders/previewImagesSkeleton';
import PlatformIconSkeleton from '../loaders/platformIconSkeleton';
import ImportedPostsMediaPreview from './importedPostsMediaPreview';
import { TIKTOK_BUSINESS_PAGE } from '../../../../config/constants';
import AltTagButton from './buttons/altTagsBtn';

export default function TiktokPostPreview({
  platform = TIKTOK_BUSINESS_PAGE,
  cropList = null,
  mediaFiles = null,
  postText = null,
  profileName = null,
  platformIcon = null,
  previewAssets,
  viewAssets
}) {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const [index, setIndex] = useState(0);
  const {
    ui: { previewMode },
    created_in_lomavis
  } = useSelector((state: any) => state.lomavisCreator);

  let videoRefs = useRef<Array<React.RefObject<HTMLVideoElement>>>([]);
  if (mediaFiles) {
    // Create an array of refs
    videoRefs = useRef(mediaFiles.map(() => React.createRef()));
  }

  const handleSelect = (selectedIndex, e) => {
    // Pause the current video
    const currentVideoElement = videoRefs?.current?.[index]?.current;
    if (currentVideoElement) {
      currentVideoElement.pause();
    }

    // Update the index state to the new slide
    setIndex(selectedIndex);

    // Play the next video
    const nextVideoElement = videoRefs.current[selectedIndex].current;
    if (nextVideoElement) {
      nextVideoElement.play();
    }
  };

  useEffect(() => {
    // Play the initial video
    const initialVideoElement = videoRefs?.current?.[index]?.current;
    if (initialVideoElement) {
      initialVideoElement.play();
    }
  }, []); // Empty dependency array means it only runs once on mount
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  return (
    <div className="w-100 m-2">
      <Card className="w-100">
        <div className="d-flex justify-content-between p-2 px-3">
          <div className="d-flex flex-row align-items-center">
            <div className="w-50px h-50px">
              <OnImagesLoaded
                onLoaded={() => {}}
                placeholder={<PlatformIconSkeleton />}
              >
                <Image
                  src={platformIcon}
                  className="img-fluid w-100 h-100"
                  roundedCircle
                />
              </OnImagesLoaded>
            </div>
            <div className="d-flex flex-column align-items-start ms-2">
              <span className="fw-bold">{profileName}</span>
              <small className="text-black-50">
                {t('lomavisCreator.previewCards.just_now')}
              </small>
            </div>
          </div>
        </div>

        {/* video/mp4 for both mp4 and mov video types */}
        {mediaFiles && mediaFiles.length > 0 && created_in_lomavis && (
          <div
            className="asset_wrapper w-100 overflow-hidden"
            style={{
              maxHeight:
                previewMode == PREVIEW_TYPE_COMPACT
                  ? COMPACT_MODE_HEIGHT
                  : '100%'
            }}
          >
            <OnImagesLoaded
              onLoaded={() => {
                setIsImageLoaded(true);
              }}
              placeholder={<PreviewImagesSkeleton />}
            >
              {isImageLoaded && (
                <div
                  style={{ zIndex: 3 }}
                  className="d-flex gap-2 justify-content-center align-items-center position-absolute ms-auto me-3 mt-3 end-0"
                >
                  <div
                    className="viewButton btn btn-sm btn-bg-white border border-dark px-3"
                    style={{
                      zIndex: 3
                    }}
                    aria-haspopup="true"
                    aria-expanded="false"
                    data-image-index="0"
                    data-crop-wrapper-id="facebookCropSlide"
                    data-platform="facebook"
                    onClick={() => viewAssets()}
                  >
                    <i
                      style={{ padding: '0px' }}
                      className="fa-regular fa-eye text-dark"
                    ></i>
                  </div>

                  <AltTagButton platform={platform} />

                  <div
                    className="btn btn-sm btn-bg-white border border-dark cropEditBtn firstImageCropEditBtn"
                    style={{ zIndex: 3 }}
                    aria-haspopup="true"
                    aria-expanded="false"
                    data-image-index="0"
                    data-crop-wrapper-id="facebookCropSlide"
                    data-platform="facebook"
                    onClick={() => previewAssets()}
                  >
                    <span className="loading-indicator spinner-border spinner-border-sm d-none"></span>
                    <span>{t('lomavisCreator.preview.edit')}</span>
                  </div>
                </div>
              )}
              <div className="w-100">
                {mediaFiles &&
                  mediaFiles.length > 0 &&
                  mediaFiles[0].type == 'video' && (
                    <div>
                      <div className="position-relative">
                        <VideoComponent
                          posterUrl={mediaFiles[0].custom_thumbnail_url}
                          videoUrl={
                            mediaFiles?.[0]?.file || mediaFiles?.[0]?.video_url
                          }
                          autoplay={false}
                          styles={{
                            maxHeight:
                              previewMode == PREVIEW_TYPE_COMPACT
                                ? COMPACT_MODE_HEIGHT
                                : '100%'
                          }}
                        />
                      </div>
                    </div>
                  )}

                {mediaFiles &&
                  mediaFiles.length > 0 &&
                  mediaFiles[0].type == 'image' && (
                    <>
                      <div className="position-relative">
                        <Image
                          className="img-fluid w-100 h-100"
                          style={{
                            objectFit: 'contain',
                            maxHeight:
                              previewMode == PREVIEW_TYPE_COMPACT
                                ? COMPACT_MODE_HEIGHT
                                : '100%'
                          }}
                          src={mediaFiles[0].image_url}
                        />
                      </div>
                    </>
                  )}
              </div>
            </OnImagesLoaded>
          </div>
        )}
        {mediaFiles && mediaFiles.length > 0 && !created_in_lomavis && (
          <div
            className="asset_wrapper w-100 overflow-hidden"
            style={{
              maxHeight:
                previewMode === PREVIEW_TYPE_COMPACT
                  ? COMPACT_MODE_HEIGHT
                  : '100%'
            }}
          >
            <ImportedPostsMediaPreview
              platform={platform}
              mediaFiles={mediaFiles}
            />
          </div>
        )}
        <div className="px-2 d-flex align-items-start my-2">
          <p className="py-2">
            {postText && (
              <span
                className="preview-text"
                style={{
                  color: 'black',
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  overflowWrap: 'break-word'
                }}
                dangerouslySetInnerHTML={{ __html: postText }}
              />
            )}
          </p>
        </div>
      </Card>
    </div>
  );
}
